var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9767.5c.20803 0 .4139.039.62384.12375l.15832.07224 12.82741 7.65237c.5141.2614.85347.76654.90646 1.33387l.00727.15614v15.65358c0 2.14697-1.68315 3.89998-3.80054 4.00425l-.19974.00491h-6.99944c-.87257 0-1.58745-.67115-1.66028-1.52568l-.00611-.14404v-7.0172c0-.33638-.2472-.61465-.56892-.66246l-.09858-.00726H13.8336c-.3349 0-.61254.24769-.66025.57072l-.00725.099v7.0172c0 .8734-.66895 1.59052-1.5225 1.66359l-.14389.00613H4.50028c-2.1433 0-3.8914-1.68795-3.99539-3.80907L.5 25.49195V9.83725c0-.5765.2959-1.1077.75367-1.39888l.12875-.07332L14.22594.67819C14.46084.56074 14.71708.5 14.97669.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFilled);
export default __webpack_public_path__ + "static/media/house-filled.70dbd1b9.svg";
export { ForwardRef as ReactComponent };